import angular from 'angular';
import complianceReviewRatingModal from './complianceReviewRatingModal';
import './style.scss';

export default angular
  .module('components.complianceReviewRatingModal', [])
  .component('complianceReviewRatingModal', complianceReviewRatingModal).name;
